import { render } from "./OverlayPage.vue?vue&type=template&id=72f91864&scoped=true"
import script from "./OverlayPage.vue?vue&type=script&lang=js"
export * from "./OverlayPage.vue?vue&type=script&lang=js"

import "./OverlayPage.vue?vue&type=style&index=0&id=72f91864&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f91864"]])

export default __exports__